module.exports = __webpack_public_path__ + "img/EmployeeCV.bbe04596.svg";